module.exports = __webpack_public_path__ + "img/pocket_tower.7f41f1de.png";